import { AxiosRequestConfig } from 'axios';
import AxiosInstance from 'src/shared/services/axios/interceptor';
import { HelpCenterCategory } from '../models/helpCenterCategory';
import { HelpCenterArticleListItem } from '../models/helpCenterArticleListItem';
import { HelpCenterArticle } from '../models/helpCenterArticle';
import { HelpCenterSearchResult } from '../models/helpCenterSearchResult';

const controller = 'help';

// Bara kategorier med artiklar som den inloggade får se, och huvudkategorierna till dem, i trädets ordning.
export const getHelpCenterCategories = () => {
  return AxiosInstance.get<HelpCenterCategory[]>(`${controller}/categories`);
};

// Artiklarna direkt i kategorin, A–Ö. skipErrorToast: en okänd eller dold kategori (404) visas på sidan istället.
export const getHelpCenterArticles = (categoryId: number) => {
  return AxiosInstance.get<HelpCenterArticleListItem[]>(`${controller}/categories/${categoryId}/articles`, { skipErrorToast: true });
};

// skipErrorToast: en okänd eller dold artikel (404) visas på sidan istället.
export const getHelpCenterArticle = (slug: string) => {
  return AxiosInstance.get<HelpCenterArticle>(`${controller}/articles/${encodeURIComponent(slug)}`, { skipErrorToast: true });
};

// Titel och text bland artiklarna den inloggade får se, med kundens benämningar. Ord under två tecken räknas inte.
// config: förslagslistan i sökfältet skickar skipErrorToast, så att ett fel inte blir en toast per paus i skrivandet.
export const searchHelpCenter = (query: string, config?: AxiosRequestConfig) => {
  return AxiosInstance.get<HelpCenterSearchResult[]>(`${controller}/search`, { ...config, params: { q: query } });
};

// Artiklarna som är taggade med modulen, A–Ö: hjälppanelens förslag. skipErrorToast: felet visas i panelen.
export const getHelpCenterArticlesByModule = (module: string) => {
  return AxiosInstance.get<HelpCenterArticleListItem[]>(`${controller}/articles`, { params: { module }, skipErrorToast: true });
};
